<template>
  <div id="app">
    <!-- 承载子路由的容器 -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue